// https://mrpmorris.blogspot.com/2017/08/angular-composite-controls-formgroup-formgroupname-reactiveforms.html
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedEditLocationSectionComponent } from '../shared-edit-location-section.component';
import { Store } from '@ngrx/store';
import { EditLocationLocalStore } from '../../edit-location-local-store.service';
import { PushPipe } from '@ngrx/component';
import { EditableCoordinateInputsComponent } from '../../editable-inputs/editable-coordinate-inputs/editable-coordinate-inputs.component';
import { EditableTextualInputComponent } from '../../editable-inputs/editable-textual-input/editable-textual-input.component';
import { IntersectionObserverDirective } from '../../../../../directives/general-intersection/intersection-observer.directive';

@Component({
    selector: 'app-geo-data-section',
    templateUrl: './geo-data.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        IntersectionObserverDirective,
        EditableTextualInputComponent,
        EditableCoordinateInputsComponent,
        PushPipe,
    ],
})
export class GeoDataSectionComponent extends SharedEditLocationSectionComponent {

  constructor(protected store: Store, protected localStore: EditLocationLocalStore) {
    super(store, localStore);
  }

}
